import baustein from "baustein";
import { svgIcon } from "web/script/modules/jinja-filters";

export default baustein.register("base-overlay", {
    render: function () {
        this.el.classList.add("overlay");

        const overlayContent = document.createElement("div");
        overlayContent.className = "overlay-content";

        const overlayClose = document.createElement("div");
        overlayClose.className = "overlay-close base-overlay__close-icon";

        const closeIcon = document.createElement("span");
        closeIcon.className = "base-overlay__close-button";
        closeIcon.innerHTML = svgIcon("cross-thin");
        overlayClose.appendChild(closeIcon);

        this.el.appendChild(overlayContent);
        this.el.appendChild(overlayClose);
    },

    setContent: function (html) {
        this.el.querySelector(".overlay-content").innerHTML = html;
    },
});
